export interface ActivityImageSize {
  width: number
  height: number
}

export const ACTIVITY_MODAL_MAX_WIDTH = 318
export const ACTIVITY_MODAL_MIN_HEIGHT = 520
export const ACTIVITY_MODAL_CHROME_HEIGHT = 78

const VERTICAL_EDGE_GAP = 24
const DEFAULT_IMAGE_SIZE = { width: 318, height: 536 }

// Preserve the existing 318x520 popup for images that fit. Expand its height
// only when the artwork needs more room; scale uniformly on short screens.
export const getActivityModalSize = (
  imageSizes: (ActivityImageSize | null)[],
  viewportWidth: number,
  viewportHeight: number,
) => {
  const availableWidth = Math.max(1, Number(viewportWidth) || 375)
  const availableWindowHeight = Math.max(1, (Number(viewportHeight) || 667) - VERTICAL_EDGE_GAP)
  const availableImageHeight = Math.max(1, availableWindowHeight - ACTIVITY_MODAL_CHROME_HEIGHT)
  const maxWidth = Math.min(ACTIVITY_MODAL_MAX_WIDTH, availableWidth)
  const sizes = imageSizes?.length ? imageSizes : []

  const fittedSizes = sizes.map((size) => {
    const width = Number(size?.width) > 0 ? Number(size?.width) : DEFAULT_IMAGE_SIZE.width
    const height = Number(size?.height) > 0 ? Number(size?.height) : DEFAULT_IMAGE_SIZE.height
    const scale = Math.min(1, maxWidth / width, availableImageHeight / height)
    return { width: Math.ceil(width * scale), height: Math.ceil(height * scale) }
  })

  return {
    width: maxWidth,
    height: Math.min(
      Math.max(ACTIVITY_MODAL_MIN_HEIGHT, ...fittedSizes.map(size => size.height + ACTIVITY_MODAL_CHROME_HEIGHT)),
      availableWindowHeight,
    ),
  }
}
